import { type ReactElement, useState } from 'react';
import { Button } from '@/shared/ui';

interface PortfolioPhotoProps {
  readonly src: string;
  readonly title: string;
  readonly onRetry: () => void;
}

/** 사진 ID·URL이 바뀔 때 리마운트하여 이전 다운로드 이벤트를 분리한다. */
export const PortfolioPhoto = ({ src, title, onRetry }: PortfolioPhotoProps): ReactElement => {
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [attempt, setAttempt] = useState(0);
  return (
    <div className="relative flex aspect-[4/3] w-full items-center justify-center overflow-hidden bg-muted/70 sm:aspect-[16/9]">
      {failed ? (
        <div className="flex flex-col items-center gap-4 p-6 text-center">
          <p className="text-sm text-muted-foreground">사진을 불러오지 못했습니다.</p>
          <Button
            variant="outline"
            size="sm"
            onClick={() => {
              setFailed(false);
              setLoading(true);
              setAttempt((value) => value + 1);
              onRetry();
            }}
          >
            사진 다시 불러오기
          </Button>
        </div>
      ) : (
        <>
          <img
            key={attempt}
            src={src}
            alt={`${title} 큰 사진`}
            loading="eager"
            className="size-full object-contain"
            onLoad={() => setLoading(false)}
            onError={() => {
              setLoading(false);
              setFailed(true);
            }}
          />
          {loading && (
            <p role="status" className="sr-only">
              사진을 불러오는 중입니다.
            </p>
          )}
        </>
      )}
    </div>
  );
};
